import React, { memo } from 'react';
import { useAppSelector } from 'js/store/hooks';
import { pick } from 'ramda';
import { Image } from 'js/components/common/Image';
import { useImageFallback } from '@theme/js/hooks/swiss/useImageFallback';
import { useGameConfig } from '@theme/js/components/common/Game/hooks';

export const GameItemBody = memo(({
    gameCode,
    value,
    imageClassName,
    matchesStart,
    matchesEnd,
    highlightMatches
}) => {
    const { themeName } = useAppSelector(pick(['themeName']));
    const { images } = useGameConfig(gameCode);
    const image = images.base || images.guest;
    const { src: landscapeImageSrc, handleError: landscapeImageHandleError } = useImageFallback({ initialSrc: image, fallbackSrc: `/${themeName}/images/LandscapePlaceholder.png`, gameCode });

    return (
        <>
            <Image
                src={landscapeImageSrc}
                alt={value}
                className={imageClassName}
                onError={landscapeImageHandleError}
            />
            <span dangerouslySetInnerHTML={{
                __html: highlightMatches({ value, matchesStart, matchesEnd })
            }} />
        </>
    );
});
